<!-- Left side column. contains the logo and sidebar -->
<aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
        <!-- Sidebar user panel -->
        <div class="user-panel">
            <div class="pull-left image">
                <img src="./assets/images/user.png" class="img-circle" alt="User Image">
            </div>
            <div class="pull-left info">
                <p>{{ username }}</p>
                <a href="javascript:void(0)"><i class="fa fa-circle text-success"></i> Online</a>
            </div>
        </div>
        <!-- search form -->
        <form action="#" method="get" [formGroup]='modeloAso' (ngSubmit)='searchCourses()' class="sidebar-form">
            <div class="e-input-group">
                <input class="e-input" type="text" formControlName='nome' style="width: 100%"
                    placeholder="Procurar cursos..." />
                <span class="e-input-group-icon fa fa-search" (click)='searchCourses()'></span>
            </div>
        </form>
        <!-- /.search form -->
        <!-- sidebar menu: style can be found in sidebar.less -->
        <ul class="sidebar-menu" data-widget="tree">

            <!-- Loading -->
            <li *ngIf="navStatus === 'loading'" class="disabled nav-loading">
                <a href="#" (click)="$event.preventDefault()">
                    <i class="fa fa-circle-notch fa-spin"></i>
                </a>
            </li>

            <!-- Error -->
            <ng-container *ngIf="navStatus === 'error'">
                <li class="disabled nav-message">
                    <a href="#" (click)="$event.preventDefault()">
                        <i class="fa fa-exclamation-circle"></i> <span>Não foi possível carregar o menu</span>
                    </a>
                </li>
                <li class="nav-retry">
                    <a href="#" (click)="$event.preventDefault(); retryNavigation()">
                        <i class="fa fa-redo"></i> <span>Tentar novamente</span>
                    </a>
                </li>
            </ng-container>

            <ng-container *ngIf="navStatus === 'loaded'">
                <ng-container *ngFor="let item of navItems">

                    <!-- Header -->
                    <li *ngIf="item.type === 'Header'" class="header">{{ item.label }}</li>

                    <!-- Separator -->
                    <li *ngIf="item.type === 'Separator'" class="separator"></li>

                    <!-- Link (disabled) -->
                    <ng-container *ngIf="item.type === 'Link' && item.disabled">
                        <li class="disabled">
                            <a href="#" (click)="$event.preventDefault()" aria-disabled="true">
                                <i [class]="item.icon"></i> <span>{{ item.label }}</span>
                                <small *ngIf="item.badge" class="label pull-right bg-blue">{{ item.badge }}</small>
                            </a>
                        </li>
                    </ng-container>

                    <!-- Link (active) -->
                    <ng-container *ngIf="item.type === 'Link' && !item.disabled">
                        <li [routerLinkActive]="'active'"
                            [routerLinkActiveOptions]="item.route === '/' ? {exact: true} : {exact: false}">
                            <a [routerLink]="item.route">
                                <i [class]="item.icon"></i> <span>{{ item.label }}</span>
                                <small *ngIf="item.badge" class="label pull-right bg-blue">{{ item.badge }}</small>
                            </a>
                        </li>
                    </ng-container>

                    <!-- Group (treeview) -->
                    <ng-container *ngIf="item.type === 'Group'">
                        <li #treeItem class="treeview" [routerLinkActive]="'active menu-open'">
                            <a href="#">
                                <i [class]="item.icon"></i> <span>{{ item.label }}</span>
                                <span class="pull-right-container">
                                    <i class="fa fa-angle-left pull-right"></i>
                                </span>
                            </a>
                            <ul class="treeview-menu">
                                <ng-container *ngFor="let child of item.children">
                                    <li *ngIf="child.type === 'Separator'" class="separator"></li>
                                    <li *ngIf="child.type === 'Link'" [routerLinkActive]="'active'">
                                        <a [routerLink]="child.route" (click)="onCollapsedTreeChildClick(treeItem)">{{ child.label }}</a>
                                    </li>
                                </ng-container>
                            </ul>
                        </li>
                    </ng-container>

                </ng-container>
            </ng-container>

            <li class="disabled">
                <a href="#" (click)="$event.preventDefault()" id="feedback-button">
                    <i class="fa fas fa-bullhorn"></i> <span>Reportar Bug/Problema</span>
                </a>
            </li>

        </ul>
    </section>
    <!-- /.sidebar -->
</aside>
